export default {
  setActiveNetwork({ commit }, network) {
    commit('SET_ACTIVE_NETWORK', network)
  }
}
